/**
 * Whether the right drawer was open on the Asistente tab, kept in this browser (localStorage
 * "assistant-drawer") so a reload comes back to it. A per-viewer convenience only: nothing clinical is
 * stored, and without storage (private window, blocked site data) the viewer simply starts closed.
 */
import type { DrawerTab } from './tabs';

const STORAGE_KEY = 'assistant-drawer';

export interface DrawerMemory {
  open: boolean;
  tab: DrawerTab;
}

export function readDrawer(): DrawerMemory | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as Partial<DrawerMemory>;
    if (typeof value.open !== 'boolean' || (value.tab !== 'assistant' && value.tab !== 'annotations')) return null;
    return { open: value.open, tab: value.tab };
  } catch {
    return null;
  }
}

export function storeDrawer(memory: DrawerMemory): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(memory));
  } catch (error) {
    console.warn('[viewer] assistant drawer state not persisted', error);
  }
}
